<template>
  <v-card elevation="1" class="transport" style="width: 100%" flat tile>
    <v-card-actions>
      <h4 class="pl-4 subtitle-2">{{ title }}</h4>
      <v-spacer />
      <v-btn icon @click="show = !show">
        <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
      </v-btn>
    </v-card-actions>
    <v-divider />
    <v-expand-transition>
      <div class="grey lighten-4" v-show="show">
        <v-card-text>
          <v-text-field
            v-if="searchable"
            class="mb-2 white"
            hide-details
            append-icon="mdi-magnify"
            outlined
            dense
            label="recherche d'activités"
            type="text"
          ></v-text-field>
          <div
            v-for="item in items"
            :key="item.id"
          >
            <label class="d-flex align-center" >
              <input class="mb-1" @click="handlefilter($event, item)" type="radio" name="price" :checked="isChecked(item.id)" />
              <span v-if="item.value" class="mx-1">{{ item.value }}</span>
              <span v-if="item.from" class="mx-1">{{ item.from }}</span>
              <span v-if="item.from && item.to" class="mx-1">-</span>
              <span v-if="item.to" class="mx-1">{{ item.to }}</span>
              <span class="caption ml-auto">({{ item.count }})</span>
            </label>
          </div>
        </v-card-text>
      </div>
    </v-expand-transition>
  </v-card>
</template>
<script>
export default {
  props: {
    field: String,
    title: String,
    items: Array,
    searchable: Boolean,
    type: String,
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    isChecked(id) {
      let filter = this.$store.state.filters.find(f => f.id === id);
      return !!filter
    },
    handlefilter(event, item) {
      console.log(event.target.checked)
      const isActive = this.$store.state.filters.find(filter => filter.id === item.id)
      if (event.target.checked && !isActive) {
          this.$store.commit("setFilter", {
            field: this.field,
            value: item.value,
            id: item.id,
            type: this.type
          });
      } else {
        this.$store.commit("removeFilter", {
          id: item.id
        });
      }
    }
  }
};
</script>